
export default {
    catalog: '',
    product: '/producto/:id',
    add: '/agregar_productos',
     };
  